import { useApiQuery } from '../../hooks/use-api';

export interface ExerciseFrequency {
  exerciseName: string;
  count: number;
}

export function useClientExerciseFrequency(clientId: string) {
  // This endpoint does not exist yet and will need to be created in the backend.
  const endpoint = `/clients/${clientId}/exercise-frequency`;
  return useApiQuery<ExerciseFrequency[]>(['clients', clientId, 'exercise-frequency'], endpoint, { enabled: !!clientId });
}